/**
 * Start for me — lightweight local persistence (V1, no backend).
 */

const SAVED_KEY = 'mlb-start-for-me-saved';
const RECENT_KEY = 'mlb-start-for-me-recent';
const PENDING_KEY = 'mlb-start-for-me-pending';
const MAX_RECENT = 12;
const MAX_SAVED = 30;

function readJson(key, fallback) {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : fallback;
  } catch {
    return fallback;
  }
}

function writeJson(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    /* ignore quota */
  }
}

export function getRecentPromptIds() {
  const ids = readJson(RECENT_KEY, []);
  return Array.isArray(ids) ? ids : [];
}

export function pushRecentPromptId(promptId) {
  if (!promptId) return;
  const next = [promptId, ...getRecentPromptIds().filter((id) => id !== promptId)].slice(0, MAX_RECENT);
  writeJson(RECENT_KEY, next);
}

export function getSavedPrompts() {
  const items = readJson(SAVED_KEY, []);
  return Array.isArray(items) ? items : [];
}

export function savePromptForLater(entry) {
  const saved = getSavedPrompts();
  const id = entry.id || `${entry.promptId}-${Date.now()}`;
  const record = {
    id,
    promptId: entry.promptId,
    mainPrompt: entry.mainPrompt,
    followUps: entry.followUps || [],
    suggestedChapter: entry.suggestedChapter || '',
    personId: entry.personId || null,
    savedAt: new Date().toISOString(),
  };
  const withoutDup = saved.filter((s) => s.promptId !== record.promptId || s.personId !== record.personId);
  writeJson(SAVED_KEY, [record, ...withoutDup].slice(0, MAX_SAVED));
  return record;
}

export function removeSavedPrompt(savedId) {
  writeJson(
    SAVED_KEY,
    getSavedPrompts().filter((s) => s.id !== savedId),
  );
}

export function setPendingStartForMe(pending) {
  try {
    sessionStorage.setItem(PENDING_KEY, JSON.stringify(pending));
  } catch {
    /* ignore */
  }
}

/** Read and clear pending action (one-shot handoff to Stories & voice). */
export function consumePendingStartForMe() {
  try {
    const raw = sessionStorage.getItem(PENDING_KEY);
    if (!raw) return null;
    sessionStorage.removeItem(PENDING_KEY);
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function peekPendingStartForMe() {
  try {
    const raw = sessionStorage.getItem(PENDING_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}
